import InputDishCost from "../../features/approveDishCost/InputDishCost";

const AccSiteMap = [
  {
    name: "Chi phí món ăn",
    path: "chi phi mon an",
    element: <InputDishCost />,
  },
];

export default AccSiteMap;
